import styled from '@emotion/styled';

export const PageContent = styled.div`
      margin: 79px auto 60px;
        padding: 0 24px;
          max-width: 1156px;
          @media screen and (max-width: 600px) {
              padding: 0 16px;
              margin-top: 60px;
          }
`;

export default PageContent;
